import {BusinessGateway} from '../../../../core-logic/gateways/api-services/business-gateway';
import {Injectable} from '@angular/core';
import {BusinessCreateModel} from '../../../../core-logic/models/business/business-create-model';
import {Observable} from 'rxjs';
import {BusinessModel, SponsorShipStatisticModel} from '../../../../core-logic/models/business/business-model';
import {BusinessUpdateModel} from '../../../../core-logic/models/business/business-update-model';
import {ErrorModel} from '../../../../core-logic/models/shared/error-model';
import {HttpClient, HttpEvent, HttpParams, HttpRequest} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {PhoneBusinessIdRoleModel} from '../../../../core-logic/models/shared/phone-business-id--role-model';
import {UserIdPhoneModel} from '../../../../core-logic/models/shared/user-id-phone-model';
import {BusinessIdBillingDetailModel} from 'src/app/core-logic/models/shared/business-id-billing-detail-model';
import {BusinessIdAmountModel} from 'src/app/core-logic/models/shared/business-id-amount-model';
import {CreditCardModel} from '../../../../core-logic/models/payment/credit-card-model';
import {PaymentMethodModel} from '../../../../core-logic/models/payment/payment-method-model';
import {BalanceModel} from 'src/app/core-logic/models/balance/balance-model';
import {BusinessIdPaymentMethodIdModel} from 'src/app/core-logic/models/shared/business-id-payment-method-id-model';
import {BusinessIdRewardModel} from 'src/app/core-logic/models/business/sub/reward/business-id-reward-model';
import {RewardModel} from 'src/app/core-logic/models/business/sub/reward/reward-model';
import {BusinessIdRewardIdArchiveModel} from 'src/app/core-logic/models/business/sub/reward/business-id-reward-id-archive-model';
import {BusinessIdRewardCreateModel} from 'src/app/core-logic/models/business/sub/reward/business-id-reward-create-model';
import {PhoneBusinessIdModel} from '../../../../core-logic/models/shared/phone-business-id-model';
import {BusinessIdDateModel} from 'src/app/core-logic/models/shared/business-id-date-model';
import {BusinessIdOptionModel} from 'src/app/core-logic/models/shared/business-id-option-model';
import {ConsumptionModel} from 'src/app/core-logic/models/shared/options-consumption/consumption-model';
import {ConsumptionDetailModel} from 'src/app/core-logic/models/shared/options-consumption/consumption-detail-model';
import {OptionConsumptionModel} from 'src/app/core-logic/models/shared/options-consumption/option-consumption-model';
import {CreateBankAccountModel} from '../../../../core-logic/models/shared/bank-account/create-bank-account-model';
import {IbanModel} from '../../../../core-logic/models/shared/bank-account/iban-model';
import {TransferFeeModel} from '../../../../core-logic/models/shared/transfer-fee-model';
import {AddressesIdsIntervalModel} from 'src/app/core-logic/models/shared/statistic/addresses-ids-interval-model';
import {StatisticDailyReportModel} from 'src/app/core-logic/models/shared/statistic/statistic-daily-report-model';
import {GlobalStatisticModel} from '../../../../core-logic/models/shared/statistic/global-statistic-model';
import {AcquisitionStatisticModel} from '../../../../core-logic/models/shared/statistic/acquisition-statistic-model';
import {AttendanceStatisticModel} from 'src/app/core-logic/models/shared/statistic/attendance-statistic-model';
import {RewardsEarnedStatisticModel} from '../../../../core-logic/models/shared/statistic/rewards-earned-statistic-model';
import {SourceWorkTimeCostModel} from 'src/app/core-logic/models/shared/options-consumption/source-work-time-cost-model';
import {LoyaltyCardStatisticModel} from 'src/app/core-logic/models/loyalty-card/loyalty-card-model';
import {LoyaltyCardsFilterModel} from 'src/app/core-logic/models/shared/statistic/loyalty-cards-filter-model';

@Injectable({providedIn: 'root'})
export class BusinessGatewayHttp implements BusinessGateway {
  constructor(private httpClient: HttpClient) {
  }

  createBusiness(createBusinessModel: BusinessCreateModel, logoBlob?: Blob): Observable<BusinessModel | ErrorModel> {
    const formData = new FormData();
    if (logoBlob) { formData.append('logo_file', logoBlob); }
    formData.append('business', JSON.stringify(createBusinessModel));
    return this.httpClient.post<BusinessModel | ErrorModel>(`${environment.fydlApi.url}/api/business`, formData);
  }

  updateBusiness(businessId: string, businessUpdateModel: BusinessUpdateModel, logoBlob?: Blob): Observable<boolean | ErrorModel> {
    const formData = new FormData();
    if (logoBlob) { formData.append('logo_file', logoBlob); }
    formData.append('business_update', JSON.stringify(businessUpdateModel));
    return this.httpClient.put<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}`, formData);
  }

  updateBusinessReward(businessIdRewardModel: BusinessIdRewardModel): Observable<RewardModel | ErrorModel> {
    return this.httpClient.post<RewardModel | ErrorModel>(`${environment.fydlApi.url}/api/business/update-reward`, businessIdRewardModel);
  }

  addBusinessReward(businessIdRewardCreateModel: BusinessIdRewardCreateModel): Observable<RewardModel | ErrorModel> {
    return this.httpClient.post<RewardModel | ErrorModel>(`${environment.fydlApi.url}/api/business/reward`, businessIdRewardCreateModel);
  }

  removeBusinessReward(businessIdRewardIdArchiveModel: BusinessIdRewardIdArchiveModel): Observable<boolean | ErrorModel> {
    return this.httpClient.post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/archive-delete-reward`,
      businessIdRewardIdArchiveModel);
  }

  getBusinesses(): Observable<BusinessModel[] | ErrorModel> {
    return this.httpClient.get<BusinessModel[] | ErrorModel>(`${environment.fydlApi.url}/api/businesses`);
  }

  getAllBusinesses(): Observable<BusinessModel[] | ErrorModel> {
    return this.httpClient.get<BusinessModel[] | ErrorModel>(`${environment.fydlApi.url}/api/all/businesses`);
  }

  getBusinessStatisticGlobal(businessId: string): Observable<GlobalStatisticModel | ErrorModel> {
    return this.httpClient.get<GlobalStatisticModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/statistic/global`);
  }

  getBusinessStatisticDailyReport(businessId: string, date: Date): Observable<StatisticDailyReportModel | ErrorModel> {
    return this.httpClient.get<StatisticDailyReportModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/statistic/daily-report`,
      {params: new HttpParams({
          fromObject: { date: date.toISOString() }
        })});
  }

  getBusinessStatisticAcquisition(businessId: string, addressesIdsIntervalModel: AddressesIdsIntervalModel): Observable<AcquisitionStatisticModel | ErrorModel> {
    return this.httpClient.get<AcquisitionStatisticModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/statistic/acquisition`,
      {params: new HttpParams({
          fromObject: {
            start: addressesIdsIntervalModel.interval.start.toISOString(),
            end: addressesIdsIntervalModel.interval.end.toISOString(),
            address_ids: addressesIdsIntervalModel.address_ids
          }
        })});
  }

  getBusinessStatisticAttendance(businessId: string, addressesIdsIntervalModel: AddressesIdsIntervalModel): Observable<AttendanceStatisticModel | ErrorModel> {
    return this.httpClient.get<AttendanceStatisticModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/statistic/attendance`,
      {params: new HttpParams({
          fromObject: {
            start: addressesIdsIntervalModel.interval.start.toISOString(),
            end: addressesIdsIntervalModel.interval.end.toISOString(),
            address_ids: addressesIdsIntervalModel.address_ids
          }
        })});
  }

  getBusinessStatisticRewards(businessId: string, addressesIdsIntervalModel: AddressesIdsIntervalModel): Observable<ErrorModel | RewardsEarnedStatisticModel> {
    return this.httpClient.get<RewardsEarnedStatisticModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/statistic/rewards`,
      {params: new HttpParams({
          fromObject: {
            start: addressesIdsIntervalModel.interval.start.toISOString(),
            end: addressesIdsIntervalModel.interval.end.toISOString(),
            address_ids: addressesIdsIntervalModel.address_ids
          }
        })});
  }

  getBusinessDefaultCreditCard(businessId: string): Observable<CreditCardModel | ErrorModel> {
    return this.httpClient.get<CreditCardModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/credit-card`);
  }

  getBusinessAuthorizedPaymentMethods(businessId: string): Observable<PaymentMethodModel [] | ErrorModel> {
    return this.httpClient.get<PaymentMethodModel [] | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/authorized-payment-methods`);
  }

  getBusinessSold(businessId: string): Observable<number | ErrorModel> {
    return this.httpClient.get<number | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/sold`);
  }

  getBusinessBalanceHistory(businessId: string): Observable<ErrorModel | BalanceModel[]> {
    return this.httpClient.get<BalanceModel[] | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/balance-history`);
  }

  getBusinessOptionConsumptionByType(businessIdOptionModel: BusinessIdOptionModel): Observable<OptionConsumptionModel | ErrorModel> {
    return this.httpClient.get<OptionConsumptionModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessIdOptionModel.business_id}/option-consumption`,
      {params: new HttpParams({fromObject: {option: businessIdOptionModel.option}})});
  }

  getBusinessConsumption(businessIdDateModel: BusinessIdDateModel): Observable<ErrorModel | ConsumptionModel> {
    return this.httpClient.get<ConsumptionModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessIdDateModel.business_id}/consumption`,
      {params: new HttpParams({fromObject: {date: businessIdDateModel.date.toISOString()}})});
  }

  getBusinessConsumptionDetail(businessIdDateModel: BusinessIdDateModel): Observable<ConsumptionDetailModel | ErrorModel> {
    return this.httpClient.get<ConsumptionDetailModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessIdDateModel.business_id}/consumption-detail`,
      {params: new HttpParams({fromObject: {date: businessIdDateModel.date.toISOString()}})});
  }

  getBusinessSourceWorkTimeCost(sourceId: string): Observable<SourceWorkTimeCostModel | ErrorModel> {
    return this.httpClient.get<SourceWorkTimeCostModel | ErrorModel>(`${environment.fydlApi.url}/api/work-time/source/${sourceId}/cost`);
  }

  checkOptionCostAvailability(businessIdOptionModel: BusinessIdOptionModel): Observable<boolean | ErrorModel> {
    return this.httpClient.get<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessIdOptionModel.business_id}/check-option-cost-availability`,
      {params: new HttpParams({fromObject: {option: businessIdOptionModel.option}})});
  }

  chargeBusiness(businessIdAmountModel: BusinessIdAmountModel): Observable<number | any | ErrorModel> {
    return this.httpClient.post<number | ErrorModel>(`${environment.fydlApi.url}/api/business/charge`, businessIdAmountModel);
  }

  uploadBusinessLogo(logoBlob: Blob): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('logo_file', logoBlob);
    const postRequest = new HttpRequest(
      'POST',
      `${environment.fydlApi.url}/api/business/logo`,
      formData,
      { reportProgress: true }
    );
    return this.httpClient.request(postRequest);
  }

  getBusinessLogoById(logoId: string): Observable<Blob> {
    // @ts-ignore
    return this.httpClient.get<Blob>(`${environment.fydlApi.url}/api/business/logo/${logoId}`, { responseType: 'blob' });
  }

  getBusinessLogoByBusinessId(businessId: string): Observable<Blob> {
    // @ts-ignore
    return this.httpClient.get<Blob>(`${environment.fydlApi.url}/api/business/${businessId}/logo`, { responseType: 'blob' });
  }

  deleteBusinessLogo(logoId: string): Observable<boolean> {
    return this.httpClient.delete<boolean>(`${environment.fydlApi.url}/api/business/logo/${logoId}`);
  }

  addBusinessAdministrator(phoneBusinessIdModel: PhoneBusinessIdRoleModel): Observable<UserIdPhoneModel | ErrorModel> {
    return this.httpClient
      .post<UserIdPhoneModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${phoneBusinessIdModel.business_id}/add-administrator`,
        {phone: phoneBusinessIdModel.phone});
  }

  addBusinessManager(phoneBusinessIdModel: PhoneBusinessIdRoleModel): Observable<UserIdPhoneModel | ErrorModel> {
    return this.httpClient
      .post<UserIdPhoneModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${phoneBusinessIdModel.business_id}/add-manager`,
        {phone: phoneBusinessIdModel.phone});
  }

  addBusinessWorker(phoneBusinessIdModel: PhoneBusinessIdRoleModel): Observable<UserIdPhoneModel | ErrorModel> {
    return this.httpClient
      .post<UserIdPhoneModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${phoneBusinessIdModel.business_id}/add-worker`,
        {phone: phoneBusinessIdModel.phone});
  }

  setBusinessBillingDetail(businessIdBillingDetailModel: BusinessIdBillingDetailModel): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/billing-detail`,
        businessIdBillingDetailModel);
  }

  setBusinessDefaultPaymentMethod(businessIdPaymentMethodIdModel: BusinessIdPaymentMethodIdModel): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/payment-method`,
        businessIdPaymentMethodIdModel);
  }

  setBusinessBankAccount(createBankAccountModel: CreateBankAccountModel): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/bank-account`, createBankAccountModel);
  }

  getBusinessBankAccountIban(businessId: string): Observable<IbanModel | ErrorModel> {
    return this.httpClient.get<IbanModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/iban`);
  }

  deleteBusinessBankAccount(businessId: string): Observable<boolean | ErrorModel> {
    return this.httpClient.delete<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/bank-account`);
  }

  getBusinessTransferFee(businessId: string): Observable<TransferFeeModel | ErrorModel> {
    return this.httpClient.get<TransferFeeModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/transfer-fee`);
  }

  transferBusinessBalance(businessId: string): Observable<boolean | ErrorModel> {
    return this.httpClient.post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/transfer`, null);
  }

  removeBusinessManagerOrWorker(phoneBusinessIdModel: PhoneBusinessIdRoleModel): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/${phoneBusinessIdModel.business_id}/remove-member`,
        {phone: phoneBusinessIdModel.phone});
  }

  changeBusinessMemberRole(phoneBusinessIdRoleModel: PhoneBusinessIdRoleModel): Observable<boolean | ErrorModel> {
    return this.httpClient.post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/change-member-role`, phoneBusinessIdRoleModel);
  }

  changeBusinessOwner(phoneBusinessIdModel: PhoneBusinessIdModel): Observable<UserIdPhoneModel | ErrorModel> {
    return this.httpClient
      .post<UserIdPhoneModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${phoneBusinessIdModel.business_id}/change-owner`,
        {phone: phoneBusinessIdModel.phone});
  }

  addBusinessSponsorship(businessId: string, point: number): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/add-sponsorship`,
        {point});
  }

  updateBusinessSponsorshipPoint(businessId: string, point: number): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/update-sponsorship`,
        {point});
  }

  enableDisableBusinessSponsorship(businessId: string, enable: boolean): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/enable-disable-sponsorship`,
        {enable});
  }

  getBusinessSponsorshipStatistic(businessId: string): Observable<SponsorShipStatisticModel | ErrorModel> {
    return this.httpClient.get<SponsorShipStatisticModel | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/sponsorship-statistic`);
  }

  getBusinessLoyaltyCards(businessId: string, loyaltyCardsFilterModel: LoyaltyCardsFilterModel): Observable<LoyaltyCardStatisticModel[] | ErrorModel> {
    return this.httpClient.get<LoyaltyCardStatisticModel[] | ErrorModel>(`${environment.fydlApi.url}/api/business/${businessId}/loyalty-cards`,
      {params: new HttpParams({fromObject: {...loyaltyCardsFilterModel}})});
  }
}
